const electricCities = [
  {
    'label': 'Barqi Tojik Dushanbe',
    'article': 28,
    'code': '0021',
    'type': 2,
    'value': 42,
    'has_kpp': false,
    'service_id': 33,
  },
  {
    'label': 'Barqi Tojik Khujand',
    'article': 5200,
    'code': '0024',
    'type': 4,
    'value': 43,
    'has_kpp': false,
    'service_id': 34,
  },
  {
    'label': 'Barqi Tojik Vahdat',
    'article': 45,
    'code': '0021',
    'type': 2,
    'value': 44,
    'has_kpp': false,
    'service_id': 35,
  },
  {
    'label': 'Barqi Tojik Norak',
    'article': 48,
    'code': '0021',
    'type': 2,
    'value': 45,
    'has_kpp': false,
    'service_id': 36,
  },
  {
    'label': 'Barqi Tojik Hisor',
    'article': 77,
    'code': '0021',
    'type': 2,
    'value': 46,
    'has_kpp': false,
    'service_id': 37,
  },
  {
    'label': 'Barqi Tojik Tursunzoda',
    'article': 44,
    'code': '0021',
    'type': 2,
    'value': 47,
    'has_kpp': false,
    'service_id': 38,
  },
  {
    'label': 'Barqi Tojik Mastchoh',
    'article': 74,
    'code': '0021',
    'type': 2,
    'value': 48,
    'has_kpp': false,
    'service_id': 39,
  },
  {
    'label': 'Barqi Tojik Guliston',
    'article': 74,
    'code': '0021',
    'type': 2,
    'value': 49,
    'has_kpp': false,
    'service_id': 40,
  },
  {
    'label': 'Barqi Tojik Asht',
    'article': 74,
    'code': '0021',
    'type': 2,
    'value': 50,
    'has_kpp': false,
    'service_id': 41,
  },
  {
    'label': 'Barqi Tojik Konibodom',
    'article': 74,
    'code': '0021',
    'type': 2,
    'value': 51,
    'has_kpp': false,
    'service_id': 42,
  },
  {
    'label': 'Barqi Tojik Istaravshan',
    'article': 75,
    'code': '0021',
    'type': 2,
    'value': 52,
    'has_kpp': false,
    'service_id': 43,
  },
  {
    'label': 'Barqi Tojik Zafarobod',
    'article': 75,
    'code': '0021',
    'type': 2,
    'value': 53,
    'has_kpp': false,
    'service_id': 44,
  },
  {
    'label': 'Barqi Tojik Spitamen',
    'article': 75,
    'code': '0021',
    'type': 2,
    'value': 54,
    'has_kpp': false,
    'service_id': 45,
  },
  {
    'label': 'Barqi Tojik Ghonchi',
    'article': 75,
    'code': '0021',
    'type': 2,
    'value': 55,
    'has_kpp': false,
    'service_id': 46,
  },
  {
    'label': 'Barqi Tojik Shahriston',
    'article': 75,
    'code': '0021',
    'type': 2,
    'value': 56,
    'has_kpp': false,
    'service_id': 47,
  },
  {
    'label': 'Barqi Tojik Kalinobod',
    'article': 75,
    'code': '0021',
    'type': 2,
    'value': 57,
    'has_kpp': false,
    'service_id': 48,
  },
  {
    'label': 'Barqi Tojik Rasulov',
    'article': 75,
    'code': '0021',
    'type': 2,
    'value': 58,
    'has_kpp': false,
    'service_id': 49,
  },
  {
    'label': 'Barqi Tojik Isfara',
    'article': 69,
    'code': '0021',
    'type': 2,
    'value': 59,
    'has_kpp': false,
    'service_id': 50,
  },
  {
    'label': 'Barqi Tojik Buston',
    'article': 76,
    'code': '0021',
    'type': 2,
    'value': 60,
    'has_kpp': false,
    'service_id': 51,
  },
  {
    'label': 'Barqi Tojik Bokhtar',
    'article': 54,
    'code': '0021',
    'type': 2,
    'value': 61,
    'has_kpp': false,
    'service_id': 52,
  },
  {
    'label': 'Barqi Tojik Shahrinav',
    'article': 103,
    'code': '0021',
    'type': 6,
    'value': 62,
    'has_kpp': false,
    'service_id': 53,
  },
  {
    'label': 'Barqi Tojik Rudaki',
    'article': 101,
    'code': '0021',
    'type': 6,
    'value': 63,
    'has_kpp': false,
    'service_id': 54,
  },
  {
    'label': 'Barqi Tojik Roghun',
    'article': 105,
    'code': '0021',
    'type': 6,
    'value': 64,
    'has_kpp': false,
    'service_id': 55,
  },
  {
    'label': 'Barqi Tojik Fayzobod',
    'article': 104,
    'code': '0021',
    'type': 6,
    'value': 65,
    'has_kpp': false,
    'service_id': 56,
  },
  {
    'label': 'Barqi Tojik Varzob',
    'article': 106,
    'code': '0021',
    'type': 6,
    'value': 66,
    'has_kpp': false,
    'service_id': 57,
  },
  {
    'label': 'Barqi Tojik Sarband',
    'article': 117,
    'code': '0021',
    'type': 6,
    'value': 67,
    'has_kpp': false,
    'service_id': 58,
  },
  {
    'label': 'Barqi Tojik Jayhun',
    'article': 115,
    'code': '0021',
    'type': 6,
    'value': 68,
    'has_kpp': false,
    'service_id': 59,
  },
  {
    'label': 'Barqi Tojik Vakhsh',
    'article': 119,
    'code': '0021',
    'type': 6,
    'value': 69,
    'has_kpp': false,
    'service_id': 60,
  },
  {
    'label': 'Barqi Tojik Dusti',
    'article': 110,
    'code': '0021',
    'type': 6,
    'value': 70,
    'has_kpp': false,
    'service_id': 61,
  },
  {
    'label': 'Barqi Tojik Kushoniyon',
    'article': 109,
    'code': '0021',
    'type': 6,
    'value': 71,
    'has_kpp': false,
    'service_id': 62,
  },
  {
    'label': 'Barqi Tojik Jomi',
    'article': 111,
    'code': '0021',
    'type': 6,
    'value': 72,
    'has_kpp': false,
    'service_id': 63,
  },
  {
    'label': 'Barqi Tojik Qubodiyon',
    'article': 114,
    'code': '0021',
    'type': 6,
    'value': 73,
    'has_kpp': false,
    'service_id': 64,
  },
  {
    'label': 'Barqi Tojik Balkhi',
    'article': 116,
    'code': '0021',
    'type': 6,
    'value': 74,
    'has_kpp': false,
    'service_id': 65,
  },
  {
    'label': 'Barqi Tojik Panj',
    'article': 113,
    'code': '0021',
    'type': 6,
    'value': 75,
    'has_kpp': false,
    'service_id': 66,
  },
  {
    'label': 'Barqi Tojik Khisrav',
    'article': 108,
    'code': '0021',
    'type': 6,
    'value': 76,
    'has_kpp': false,
    'service_id': 67,
  },
  {
    'label': 'Barqi Tojik Kulob',
    'article': 107,
    'code': '0021',
    'type': 6,
    'value': 77,
    'has_kpp': false,
    'service_id': 68,
  },
  {
    'label': 'Barqi Tojik Panjakent',
    'article': 127,
    'code': '0021',
    'type': 6,
    'value': 78,
    'has_kpp': false,
    'service_id': 69,
  },
  {
    'label': 'Barqi Tojik Ayni',
    'article': 123,
    'code': '0021',
    'type': 6,
    'value': 79,
    'has_kpp': false,
    'service_id': 70,
  },
  {
    'label': 'Barqi Tojik K.Mastchoh',
    'article': 124,
    'code': '0021',
    'type': 6,
    'value': 80,
    'has_kpp': false,
    'service_id': 71,
  },
  {
    'label': 'Barqi Tojik Rasht',
    'article': 137,
    'code': '0021',
    'type': 6,
    'value': 81,
    'has_kpp': false,
    'service_id': 72,
  },
  {
    'label': 'Barqi Tojik Nurobod',
    'article': 136,
    'code': '0021',
    'type': 6,
    'value': 82,
    'has_kpp': false,
    'service_id': 73,
  },
  {
    'label': 'Barqi Tojik Lakhsh',
    'article': 134,
    'code': '0021',
    'type': 6,
    'value': 83,
    'has_kpp': false,
    'service_id': 74,
  },
  {
    'label': 'Barqi Tojik Dangara',
    'article': 130,
    'code': '0021',
    'type': 6,
    'value': 84,
    'has_kpp': false,
    'service_id': 75,
  },
  {
    'label': 'Barqi Tojik Sangvor',
    'article': 138,
    'code': '0021',
    'type': 6,
    'value': 85,
    'has_kpp': false,
    'service_id': 76,
  },
  {
    'label': 'Barqi Tojik Muminobod',
    'article': 135,
    'code': '0021',
    'type': 6,
    'value': 86,
    'has_kpp': false,
    'service_id': 77,
  },
  {
    'label': 'Barqi Tojik Tojikobod',
    'article': 141,
    'code': '0021',
    'type': 6,
    'value': 87,
    'has_kpp': false,
    'service_id': 78,
  },
  {
    'label': 'Barqi Tojik Yovon',
    'article': 121,
    'code': '0021',
    'type': 6,
    'value': 88,
    'has_kpp': false,
    'service_id': 79,
  },
  {
    'label': 'Barqi Tojik Vose',
    'article': 120,
    'code': '0021',
    'type': 6,
    'value': 89,
    'has_kpp': false,
    'service_id': 80,
  },
  {
    'label': 'Barqi Tojik Farkhor',
    'article': 131,
    'code': '0021',
    'type': 6,
    'value': 90,
    'has_kpp': false,
    'service_id': 81,
  },
  {
    'label': 'Barqi Tojik Baljuvon',
    'article': 129,
    'code': '0021',
    'type': 6,
    'value': 91,
    'has_kpp': false,
    'service_id': 82,
  },
  {
    'label': 'Barqi Tojik Hamadoni',
    'article': 132,
    'code': '0021',
    'type': 6,
    'value': 92,
    'has_kpp': false,
    'service_id': 83,
  },
  {
    'label': 'Barqi Tojik Khovaling',
    'article': 133,
    'code': '0021',
    'type': 6,
    'value': 93,
    'has_kpp': false,
    'service_id': 84,
  },
  {
    'label': 'Barqi Tojik Shohin',
    'article': 139,
    'code': '0021',
    'type': 6,
    'value': 94,
    'has_kpp': false,
    'service_id': 85,
  },
  {
    'label': 'Barqi Tojik Temurmalik',
    'article': 140,
    'code': '0021',
    'type': 6,
    'value': 95,
    'has_kpp': false,
    'service_id': 86,
  },
  {
    'label': 'Barqi Tojik Khorug',
    'article': 80,
    'code': '0026',
    'type': 9,
    'value': 96,
    'has_kpp': false,
    'service_id': 87,
  },
  {
    'label': 'Barqi Tojik Gafurov',
    'article': 74,
    'code': '0021',
    'type': 2,
    'value': 97,
    'has_kpp': false,
    'service_id': 88,
  },
  {
    'label': 'Barqi Tojik Shahritus',
    'article': 118,
    'code': '0021',
    'type': 6,
    'value': 98,
    'has_kpp': false,
    'service_id': 89,
  },
  {
    'label': 'Barqi Tojik Khuroson',
    'article': 112,
    'code': '0021',
    'type': 6,
    'value': 99,
    'has_kpp': false,
    'service_id': 90,
  },
  {
    'label': 'Barqi Tojik Rudaki-2',
    'article': 102,
    'code': '0021',
    'type': 6,
    'value': 258,
    'has_kpp': false,
    'service_id': 245,
  },
];

export default electricCities;
